module.exports = __webpack_public_path__ + "img/white.895eac0.svg";